import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteUserExternalAccount } from '@arrived/api_v2';
import { Account, AccountId } from '@arrived/models';

import { UseMutationOptions } from '../../queries.utils';
import { accountsPrimaryKeyFn } from '../../users';
import { accountsKeyFn } from '../accounts.keys';

export function useDeleteExternalAccountMutation(options?: UseMutationOptions<void, AccountId>) {
  const queryClient = useQueryClient();

  return useMutation((accountId) => deleteUserExternalAccount(accountId), {
    ...options,
    onSuccess: (data, variables, context) => {
      // TODO: Track delete event.
      const primaryAccount = queryClient.getQueryData<Account>(accountsPrimaryKeyFn());

      if (primaryAccount && primaryAccount.id === variables) {
        queryClient.setQueryData(accountsPrimaryKeyFn(), { ...primaryAccount, externalAccount: undefined });
      }

      const account = queryClient.getQueryData<Account>(accountsKeyFn(variables));

      if (account) {
        queryClient.setQueryData(accountsKeyFn(variables), { ...account, externalAccount: undefined });
      }

      queryClient.invalidateQueries(accountsPrimaryKeyFn());
      // TODO: This should really only be necessary in the admin portals, but we have some legacy routes that reference
      //  the specific account ID that are exposed to the user.
      queryClient.invalidateQueries(accountsKeyFn(variables));

      options?.onSuccess?.(data, variables, context);
    },
  });
}
